import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { DriversService } from 'src/app/root/drivers.service';
import { SnackBarService } from 'src/app/shared/snackbar.service';
import { UserInvite } from 'src/app/types';

interface FormGroupValue {
  name: string;
  phoneNumber: string;
  email: string;
  password: string;
}

@Component({
  selector: 'lohi-invite-admin',
  templateUrl: './invite-admin.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteAdminComponent implements OnInit, OnDestroy {
  private destroy$$ = new Subject();
  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private driversService: DriversService,
    private snackBar: SnackBarService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: [null, [Validators.required]],
      phoneNumber: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]],
    });
  }

  public ngOnDestroy() {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  public async invite() {
    if (this.formGroup.invalid) {
      return;
    }

    const value: FormGroupValue = this.formGroup.value;
    const userInvite: UserInvite = {
      id: null,
      name: value.name,
      phoneNumber: value.phoneNumber,
      email: value.email,
      permissions: ['admin'],
      password: value.password,
      cut: 0,
      cdl: null,
      eldGroupId: null,
    };

    const success = await this.driversService.inviteUser(userInvite);
    if (!success) {
      return;
    }

    this.snackBar.showMessage('User Invited!');
    this.router.navigate(['/', 'drivers']);
  }
}
